<div class="video-container dark" [@videoContainer] [class.cover]="cover" [class.contain]="contain">
  <video
    #video
    [poster]="poster"
    [width]="videoData?.width"
    [height]="videoData?.height"
    [controls]="false"
    [muted]="muted"
    [loop]="loop"
    [style.object-position]="coverPosition"
    (pointerdown)="videoClick()"
  ></video>
  @if (status !== 'playing') {
    <img
      [src]="poster"
      alt=""
      [width]="videoData?.width"
      [height]="videoData?.height"
      [style.object-position]="coverPosition"
    />
  }
  @if (activateOnClick && !active && status === 'idle') {
    <div class="initial-play-hitbox" (click)="initialPlayClick()"></div>
    @if (handleUi) {
      <div class="initial-play-button" (click)="initialPlayClick()" [@initialPlayButton]>
        <app-svg src="/assets/icons/play.svg"></app-svg>
      </div>
    }
  }
  @if (!activateOnClick || active) {
    @if (handleUi) {
      <div class="play-pause-indicator" [@playPauseIndicator]="showPlayPauseIndicator ? 'visible' : 'hidden'">
        @if (!video.paused) {
          <app-svg src="/assets/icons/play.svg" size="2"></app-svg>
        }
        @if (video.paused) {
          <app-svg src="/assets/icons/pause.svg" size="2"></app-svg>
        }
      </div>
    }
    <div class="play-pause-indicator" [@playPauseIndicator]="showMuteIndicator ? 'visible' : 'hidden'">
      @if (muted) {
        <app-svg src="/assets/icons/volume-mute.svg" size="2"></app-svg>
      }
      @if (!muted) {
        <app-svg src="/assets/icons/volume-full.svg" size="2"></app-svg>
      }
    </div>
    @if (handleUi) {
      <div
        class="play-pause-indicator"
        [@timeSkipIndicator]="
          showTimeSkipIndicator ? 'visible_' + lastTimeSkipDirection : 'hidden_' + lastTimeSkipDirection
        "
      >
        <app-svg src="/assets/icons/video-{{ lastTimeSkipDirection }}-5.svg" size="2"></app-svg>
      </div>
    }
    @if (handleUi) {
      <div class="play-pause-indicator" [@playPauseIndicator]="showSpeedIndicator ? 'visible' : 'hidden'">
        <app-svg src="/assets/icons/play-speed-{{ speed }}.svg" size="2"></app-svg>
      </div>
    }
    @if (showUi) {
      @if (accessLevel && accessLevel !== 'view_only' && gallery && commentFace$ | async; as threads) {
        @for (thread of threads; track thread.id) {
          @if (!thread.resolved || showResolved) {
            <!-- accessLevel === 'edit' || (thread.user || thread.guest | isCurrentUser) -->
            <div
              class="comment-face"
              [class.allow-drag]="false"
              [class.selected]="selectedThreadId === thread.id"
              [class.disable-pointer-events]="mouseDownOnTimeline"
              [class.dragging]="draggingThread?.id === thread.id || potentiallyDraggingThread?.id === thread.id"
              (click)="selectThread.emit(thread)"
              (mousedown)="threadMouseDown($event, thread)"
              (mousemove)="threadMouseMove($event)"
              (mouseleave)="threadMouseUpOrLeave()"
              (mouseup)="threadMouseUpOrLeave()"
              [style.left]="
                ((thread.position.frame | isArray)
                  ? thread.position.frame[0] + (thread.position.frame[1] - thread.position.frame[0]) / 2
                  : thread.position.frame) *
                  100 +
                '%'
              "
            >
              <app-avatar [user]="thread.user || thread.guest"></app-avatar>
            </div>
          }
        }
      }

      <div
        class="timeline dont-hide-controls"
        (pointerdown)="mousedown($event)"
        (pointermove)="mousemove($event)"
        (touchmove)="touchTimelineInteraction($event)"
        (touchstart)="touchTimelineInteraction($event)"
        (pointerleave)="currentHoverPosition = null; mouseDownOnTimeline = false"
        (pointerup)="currentHoverPosition = null; mouseDownOnTimeline = false"
        [class.mousedown]="mouseDownOnTimeline"
        [@timeline]
      >
        @if (currentHoverPosition !== null) {
          <app-video-thumbnail
            @thumbnail
            [currentTime]="currentHoverTime"
            [assetVersion]="assetVersion"
            [showTime]="true"
            [constrainWidth]="true"
            [style.left]="currentHoverPosition + 'px'"
          ></app-video-thumbnail>
        }

        <div class="timeline-inner">
          <div class="buffer-pieces">
            @for (buffer of buffered; track buffer) {
              <div
                [style.width]="buffer.end - buffer.start + '%'"
                [style.left]="buffer.start + '%'"
                class="buffer"
              ></div>
            }
          </div>
          <div class="past-played" #pastPlayed [style.width]="(video.currentTime / video.duration) * 100 + '%'"></div>
        </div>
      </div>
    }
    @if (showUi) {
      <div class="controls-container">
        <div class="video-controls dont-hide-controls" [@controls]>
          <button
            (click)="playPauseClick($event)"
            ignore-touch-ui-toggle="true"
            appButton
            [name]="video.paused ? 'play' : 'paused'"
            location="video-viewer"
            [iconButton]="true"
            height="1"
            color="hard-simple"
            shape="round"
            [appTooltip]="video.paused ? 'Play' : 'Pause'"
            [tooltipKeyboardShortcut]="'SPACE'"
            [toolTipOrigin]="scale > 0.9 ? 'top-left' : 'top'"
          >
            @if (video.paused) {
              <app-svg src="/assets/icons/play.svg" color="white"></app-svg>
            }
            @if (!video.paused) {
              <app-svg src="/assets/icons/pause.svg" color="white"></app-svg>
            }
          </button>
          @if (assetVersion.data['audio_codec']) {
            <div class="volume-container">
              <button
                (click)="toggleMute()"
                [appTooltip]="muted ? 'Unmute' : 'Mute'"
                [tooltipKeyboardShortcut]="'M'"
                class="volume-button"
                appButton
                [name]="muted ? 'unmute' : 'mute'"
                location="video-viewer"
                [iconButton]="true"
                height="1"
                color="hard-simple"
                shape="round"
              >
                @if (muted) {
                  <app-svg src="/assets/icons/volume-mute.svg" color="white"></app-svg>
                }
                @if (!muted && volume < 0.5) {
                  <app-svg src="/assets/icons/volume-low.svg" color="white"></app-svg>
                }
                @if (!muted && volume >= 0.5) {
                  <app-svg src="/assets/icons/volume-full.svg" color="white"></app-svg>
                }
              </button>
              <div class="volume-slider">
                <input type="range" min="0" max="1" step="0.01" [(ngModel)]="volume" (input)="adjustVolume()" />
                <label [style.--volume-slider-value]="volume * 100 + '%'"></label>
              </div>
            </div>
          }
          <div class="spacer"></div>
          <app-context-menu [options]="{ width: '240px', noSpacing: true }" #speedMenu>
            <button
              appButton
              name="speed"
              location="video-viewer"
              [iconButton]="true"
              height="1"
              color="hard-simple"
              shape="round"
              [appTooltip]="'Playback Speed'"
              contextButton
            >
              <app-svg src="/assets/icons/play-speed-{{ speed }}.svg" color="white"></app-svg>
            </button>
            <div contextContent class="button-menu dont-hide-controls">
              <h3 class="menu-list-title">SPEED</h3>
              @for (_speed of speeds; track _speed) {
                <button
                  appButton
                  name="speed-adjust"
                  location="video-viewer"
                  (click)="adjustSpeed(_speed); speedMenu.close()"
                  [color]="speed === _speed ? 'simple-primary' : 'simple'"
                  spacing="full"
                >
                  <div class="check-button">
                    <span>
                      @if (_speed !== 1) {
                        {{ _speed | number: '1.1-1' }}x
                      } @else {
                        Normal
                      }
                    </span>
                    @if (_speed === speed) {
                      <app-svg src="/assets/icons/check.svg" post class="some-check"></app-svg>
                    }
                  </div>
                </button>
              }
            </div>
          </app-context-menu>
          @if (hlsSupported && !isMobile) {
            <app-context-menu [options]="{ width: '240px', noSpacing: true }" #qualityMenu>
              <button
                appButton
                name="resolution"
                location="video-viewer"
                [iconButton]="true"
                height="1"
                color="hard-simple"
                shape="round"
                [appTooltip]="'Quality'"
                [toolTipOrigin]="scale > 0.9 ? 'top-right' : 'top'"
                contextButton
              >
                <app-svg
                  src="/assets/icons/resolution-{{ levels[currentLevel] | videoResolutionType }}.svg"
                  color="white"
                ></app-svg>
              </button>
              <div contextContent class="button-menu dont-hide-controls">
                <h3 class="menu-list-title">QUALITY</h3>
                @for (level of levels; track level; let i = $index) {
                  <button
                    appButton
                    name="resolution"
                    [hasIcon]="true"
                    location="video-viewer"
                    (click)="loadLevel(i); qualityMenu.close()"
                    [color]="i === currentLevel ? 'simple-primary' : 'simple'"
                    spacing="full"
                  >
                    <app-svg [src]="'/assets/icons/resolution-' + (level | videoResolutionType) + '.svg'"></app-svg>
                    <div class="check-button">
                      <span>{{ level.width > level.height ? level.height : level.width }}p</span>
                      @if (i === currentLevel) {
                        <app-svg src="/assets/icons/check.svg" post class="some-check"></app-svg>
                      }
                    </div>
                  </button>
                }
              </div>
            </app-context-menu>
          } @else if (isMobile) {
            <button
              (click)="toggleFullscreen()"
              appButton
              name="fullscreen"
              location="video-viewer"
              [iconButton]="true"
              height="1"
              color="hard-simple"
              shape="round"
            >
              <app-svg src="/assets/icons/fullscreen-enter.svg" color="white"></app-svg>
            </button>
          }
        </div>
      </div>
    }
  }
  @if (allowUnmute && status === 'playing' && assetVersion.data['audio_codec']) {
    <button
      (click)="toggleMutePreventDefault($event)"
      [appTooltip]="muted ? 'Unmute' : 'Mute'"
      class="mute-toggle"
      appButton
      [name]="muted ? 'unmute' : 'mute'"
      location="video-viewer"
      [iconButton]="true"
      height="1"
      color="hard-simple"
      shape="round"
    >
      @if (muted) {
        <app-svg src="/assets/icons/volume-mute.svg" color="white"></app-svg>
      }
      @if (!muted) {
        <app-svg src="/assets/icons/volume-full.svg" color="white"></app-svg>
      }
    </button>
  }
</div>
